import { render, staticRenderFns } from "./PostList.vue?vue&type=template&id=18f12eea&scoped=true"
import script from "./PostList.vue?vue&type=script&lang=js"
export * from "./PostList.vue?vue&type=script&lang=js"
import style1 from "./PostList.vue?vue&type=style&index=1&id=18f12eea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f12eea",
  null
  
)

export default component.exports